export const ISSUE_WORKFLOW_EXECUTION_TYPE_VALUES = [
  'parallel',
  'sequential',
] as const;

export type IssueWorkflowExecutionType =
  (typeof ISSUE_WORKFLOW_EXECUTION_TYPE_VALUES)[number];

export const ISSUE_WORKFLOW_EXECUTION_TYPE = {
  PARALLEL: 'parallel',
  SEQUENTIAL: 'sequential',
} as const;

export const IssueWorkflowExecutionTypeValues = Object.values(
  ISSUE_WORKFLOW_EXECUTION_TYPE,
) as [
  (typeof ISSUE_WORKFLOW_EXECUTION_TYPE)[keyof typeof ISSUE_WORKFLOW_EXECUTION_TYPE],
];
